import { Button, Group, Pagination } from "@mantine/core";

interface PaginationProps {
  activePage: number;
  total: number;
  onPageChange: (page: number) => void;
  showClear?: boolean;
  onClearFilters?: () => void;
}

export const PaginationBlock = ({
  activePage,
  total,
  onPageChange,
  showClear,
  onClearFilters,
}: PaginationProps) => (
  <Group justify="right" mt="md">
    {showClear && (
      <Button variant="light" size="xs" color="grape" onClick={onClearFilters}>
        Clear Filters
      </Button>
    )}
    <Pagination
      value={activePage}
      onChange={onPageChange}
      total={total}
      withEdges
    />
  </Group>
);
